import { mountAdditionalVueInstance } from '@/utils/init-vue-helpers';

mountAdditionalVueInstance({
  fn: () => import('@/features/complex-queries/complex-queries.vue'),
  // ALVIN/TODO: This is a temporary id. We will change it to 'vue-app-complex-queries' once the complex queries feature is ready.
  htmlElementId: 'vue-app-query-builder'
})